import React from "react";
import "./App.css";
import FrontPage from "./views/general/frontpage";
import "bootstrap/dist/css/bootstrap.min.css";

/* Default page when application runs: Shows FrontPage component */

function App() {
  return (
    <div className="App">
      <FrontPage />
    </div>
  );
}

export default App;
